import { useSearchParams } from '../../routes/utils/use-search-params';
import { InputContext, useInputContext } from './use-input-context';

export interface DetailsSearchParams extends InputContext {
  page: string | undefined;
  section: string | undefined;
  includeExpired: boolean | undefined;
}

export function useDetailsSearchParams(): DetailsSearchParams {
  const search = useSearchParams();
  const inputContext = useInputContext();

  return {
    ...inputContext,
    page: search.get('page') || undefined,
    section: search.get('section') || undefined,
    includeExpired: search.get('includeExpired') === 'true' || undefined,
  };
}
